// Original code from : https://markus.oberlehner.net/blog/transition-to-height-auto-with-vue/

export function useEnter(element: HTMLElement): void {
  const width = getComputedStyle(element).width

  element.style.width = width
  element.style.position = 'absolute'
  element.style.visibility = 'hidden'
  element.style.height = 'auto'

  const height = getComputedStyle(element).height

  element.style.width = ''
  element.style.position = ''
  element.style.visibility = ''
  element.style.height = '0'

  // Force repaint to make sure the
  // animation is triggered correctly.
  // eslint-disable-next-line
  getComputedStyle(element).height

  // Trigger the animation.
  // We use `setTimeout` because we need
  // to make sure the browser has finished
  // painting after setting the `height`
  // to `0` in the line above.
  setTimeout(() => {
    element.style.height = height
  })
}

export function useAfterEnter(element: HTMLElement): void {
  element.style.height = 'auto'
}

export function useLeave(element: HTMLElement): void {
  const height = getComputedStyle(element).height

  element.style.height = height

  // Force repaint to make sure the
  // animation is triggered correctly.
  // eslint-disable-next-line
  getComputedStyle(element).height

  setTimeout(() => {
    element.style.height = '0'
  })
}
